import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getQueryClientInstance } from '@/api/queries/queryClient';
import { useToast } from '@/storybook/components/Toast/Toast';
import { userProfileCacheKeys } from '../../userProfile/cacheKeys';
import { FavoriteApiService, FavoriteHcpApiParams } from '@/api/queries/hcoHcp/FavoriteApiService';

const queryClient = getQueryClientInstance();

export const usePostFavoriteHcp = () => {
  const { t } = useTranslation();
  const { makeToast } = useToast();

  return useMutation({
    mutationFn: ({ userId, hcpBk }: FavoriteHcpApiParams) =>
      FavoriteApiService.add({ userId, profileBk: hcpBk, profileType: 'HCP' }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: userProfileCacheKeys.fetch });
    },
    onError: () => makeToast({ content: t('main.error.errorOccurred'), appearance: 'error' }),
  });
};
